// Amortization helpers (French system)

export function monthlyPayment(principal, monthlyRatePct, cuotas) {
  const P = Number(principal) || 0;
  const n = Number(cuotas) || 0;
  const r = Number(monthlyRatePct) / 100;
  if (P <= 0 || n <= 0) return 0;
  if (r === 0) return P / n;
  return (P * r) / (1 - Math.pow(1 + r, -n));
}

export function simulate(principal, monthlyRatePct, cuotas) {
  const P = Math.max(0, Number(principal) || 0);
  const n = Math.max(0, Math.floor(Number(cuotas) || 0));
  const r = Math.max(0, Number(monthlyRatePct) || 0) / 100;
  const monthly = monthlyPayment(P, monthlyRatePct, n);
  const total = monthly * n;
  const interest = Math.max(0, total - P);
  // amortization schedule
  let balance = P;
  const rows = [];
  for (let i = 1; i <= n; i++) {
    const interestPortion = r === 0 ? 0 : balance * r;
    const principalPortion = Math.min(balance, monthly - interestPortion);
    balance = Math.max(0, balance - principalPortion);
    rows.push({
      i,
      payment: monthly,
      interest: interestPortion,
      principal: principalPortion,
      balance,
    });
  }
  return {
    monthly,
    total,
    interest,
    principal: P,
    cuotas: n,
    ratePct: Number(monthlyRatePct) || 0,
    rows,
  };
}
